import { React, useState, useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import imageValidator from '../../../utils/helpers/imageValidator';
import closeIcon from '../../../assets/images/CloseIcon.svg';
import { useMutation, useLazyQuery } from '@apollo/client';
import { REMOVE_IMAGE, UPLOAD_FILE } from '../../../gql/auth/mutation';
import { GET_PROFILE } from '../../../gql/auth/queries';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {IMAGE_URL} from '../../../configUrl';

function PhotoUpload() {
    const [smShow, setSmShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null)
    const [image, setImage] = useState('');
    const [isUploaded, setIsUploaded] = useState(false)
    const [validExt, setValidExt] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false)
    const [removeSuccess, setRemoveSuccess] = useState(false)
    
    const [fName, setFName] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [uploadFile, { loading }] = useMutation(UPLOAD_FILE, {
        onCompleted(data) {
            if(data?.uploadProfileImage?.url){
                setUploadSuccess(true) 
            }
        },
        refetchQueries: [
            'Me'
        ],
        onError(error) {
            if (error) {
              if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                setErrorMessage("Check Your Network, Your Browser Is Offline")
              }
              if (error.message) {
                setErrorMessage(error.message)
              }
              if (!error.message) {
                setErrorMessage("Something Went Wrong !")
              }
            }
          }
    })

    const [loadUser, { data: profileData }] = useLazyQuery(GET_PROFILE, {
        onCompleted(data) {
          setFName(data?.me?.firstName)
        },
        onError(error) {
          if (error) {
            if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
              setErrorMessage("Check Your Network, Your Browser Is Offline")
            }
            if (error.message) {
              setErrorMessage(error.message)
            }
            if (!error.message) {
              setErrorMessage("Something Went Wrong !")
            }
          }
        }
      });

      const [removeImage, {loading: removeLoading}] = useMutation(REMOVE_IMAGE, {
          onCompleted(data){
            setRemoveSuccess(true)
          },
          onError(error) {
            if (error) {
              if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                setErrorMessage("Check Your Network, Your Browser Is Offline")
              }
              if (error.message) {
                setErrorMessage(error.message)
              }
              if (!error.message) {
                setErrorMessage("Something Went Wrong !")
              }
            }
          },
        refetchQueries: [
            'Me'
        ],
    })

    const [extError, setExtError] = useState('');
    const [sizeError, setSizeError] = useState('')

    const fileInput = useRef(null)

    useEffect(() => {
        loadUser()
        // eslint-disable-next-line
      }, [])

    const fileSelectedHandler = (e) => {

        if (e.target.files && e.target.files[0]) {
            const name = e.target.files[0].name;
            const { extValid, ext, sizeValid } = imageValidator(name, e.target.files[0]);
            if(!extValid){
                setValidExt(false)
                setSizeError('')
                return setExtError(`.${ext} extension is not allowed`)
            }
            if(!sizeValid){
                setValidExt(false)
                setExtError('')
                return setSizeError(`Image size should be less than 3MB .`)
            }
            if (extValid && sizeValid) {
                setValidExt(true)
                setExtError('')
                setSizeError('')
                let reader = new FileReader()
                reader.onload = function (e) {
                    setImage(e.target.result)
                    setIsUploaded(true)
                }

                reader.readAsDataURL(e.target.files[0])
                setSelectedFile(e.target.files[0])

                // fileInput.current.files = null;
                
                // window.addEventListener('change', event => {
                //     event.preventDefault()
                // })

                // document.getElementById("myFile").value = "";
            }


        }
    }

    const handleFile = () => {
        fileInput.current.dispatchEvent(
            new Event("change", {
                bubbles: true,
                cancelable: true,
            })
        );
        fileInput.current.click()
    }


    const handleSaveFile = () => {
        if(selectedFile){
            uploadFile({
                variables: {
                    file: selectedFile
                }
            })
        }
    }

    if(uploadSuccess){
        setSmShow(false)
        toast.success("Profile Image Uploaded Successfully.", {
            position: "bottom-right",
            // closeOnClick: true,
            // autoClose: 1000,
        }) 
        setUploadSuccess(false)
    }

    if(removeSuccess){
        toast.success("Profile Image Removed Successfully.", {
            position: "bottom-right",
        }) 
        setRemoveSuccess(false)
    }

    if(errorMessage){
        toast.error(errorMessage, {
          position: "bottom-right",
          closeOnClick: true,
        })
        setErrorMessage('')
    }

    const handleRemoveImage = () => {
        if(profileData?.me?.profileImage ){
            removeImage()
        }
    }
    
    return (
        <>
        <div className='profile-pic'>
            {/* <p>PROFILE PICTURE</p> */}
            <label>Profile Picture</label>
            <div className='profile-wrapper'>
                <div className='profile-placeholder'>
                    {/* Add if else condition here, if image is there image tag else first letter of first name */}
                    {/* B */}
                    {
                        profileData && profileData?.me?.profileImage ? 
                        <img src={IMAGE_URL+profileData.me.profileImage} alt="pImage" />
                        :
                        fName && fName[0]
                    }
                    {/* <img src="" alt="" /> */}
                </div>
                <div className='profile-pic-info'>
                    <div className='profile-btns'>
                        <button onClick={() => setSmShow(true)} className='solid-button'>Upload New Photo</button>
                        {/* <input type="file" /> */}
                        {
                            removeLoading ?
                            <button className='border-button'>Remove &nbsp;
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            </button>
                            :
                            profileData?.me?.profileImage ? 
                            <button className='border-button' onClick={handleRemoveImage} >Remove</button>
                            : ""
                        }
                    </div>
                    <p>You can upload jpg or png images files. <br /> Max size of 3mb.</p> 
                </div>
            </div>
            <Modal
                size="md"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Upload Profile Picture
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='select_btn_div'>
                        <input
                            style={{ display: 'none' }}
                            id="myFile"
                            type="file"
                            onChange={fileSelectedHandler}
                            ref={fileInput}
                        />
                        {
                            !isUploaded ? (
                                <>
                                    {/* <button onClick={() => fileInput.current.click()} className="solid-button">Select File</button> */}
                                    <button onClick={() => handleFile()} className="solid-button">Select File</button>
                                </>
                            )
                                :
                                (
                                    <div className="imagePreview" >
                                        <img
                                            src={closeIcon}
                                            className="closeIcon"
                                            alt="closeIcon"
                                            onClick={() => {
                                                setIsUploaded(false)
                                                setImage('')
                                                setSelectedFile(null)
                                                document.getElementById("myFile").value = ""; 
                                                setExtError('')
                                                setSizeError('')
                                            }}
                                        />
                                        <img
                                            src={image}
                                            draggable={false}
                                            className="uploadeds-img img-fluid"
                                            alt="uploaded-img"
                                        />
                                    </div>
                                )
                        }
                    </div>
                    <div className="save_btn_div" >
                        <div className="image_name" >{selectedFile && selectedFile.name}</div>
                        <div className="image_name" style={{ color: 'red' }} >{extError && extError}</div>
                        <div className="image_name" style={{ color: 'red' }} >{sizeError && sizeError}</div>

                        {
                            loading ?
                            <>
                             <button
                                className={validExt === false ? 'save_btn_disabled solid-button' : 'save_btn solid-button'}
                            >Save &nbsp;
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            </button>
                            </>
                            :
                            selectedFile ?
                            <>
                                <button
                                onClick={handleSaveFile}
                                // disabled={validExt === false ? true : false}
                                    className={validExt === false ? 'save_btn_disabled solid-button' : 'save_btn solid-button'}
                                >
                                    Save
                                </button>
                            </>
                            :
                            <></>
                        }
                        {/* loading ? spinner : selectedFile ->button  : <></>*/}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
        </>
    )
}

export default PhotoUpload;
